import { ValidateType } from "./types";

const validator = async <T>({
  values,
  validationSchema,
  onClick,
}: ValidateType<T>) => {
  const result = await validationSchema
    .validate(values, { abortEarly: false })
    .catch((err) => {
      return err;
    });
  if ((!result?.inner || result?.inner?.length === 0) && onClick) {
    onClick();
  }

  if (result?.inner?.length > 0) {
    const positions = result?.inner?.map((e: { path: string }) => {
      const el = document.getElementsByName(e.path);
      if (el && el.length > 0) {
        const pos = el[0].getBoundingClientRect();
        return pos.top;
      }
      return undefined;
    });

    const sorted = positions
      .filter((p: number | undefined) => p !== undefined)
      .sort((a: number, b: number) => a - b);

    if (sorted && sorted?.length > 0) {
      const navbarHeight = 93;
      const viewport = window.innerHeight;
      const top = window.scrollY + sorted[0] - navbarHeight - viewport * 0.2;
      window.scroll({
        top,
        left: 0,
        behavior: "smooth",
      });
    }
  }
};

export default validator;
